require('./iron/common/stylesheets/defaults/color-vars.styl');
require('./media/less/widgets/calendar.less');
require('./media/less/widgets/property_dropdowns_d2.less');
require('./media/less/widgets/toggle.less');
require('./media/less/static/landing/marketing/trends.less');
require('./media/plugins/rison.es5.js');
require('./media/js/extensions/jquery.ui.core.es5.js');
require('./media/js/extensions/jquery.ui.datepicker.es5.js');
require('./media/js/extensions/jquery.scrollTo-min.es5.js');
require('./media/js/date_range.es5.js');
require('./media/plugins/highcharts/excanvas.es5.js');
require('./media/plugins/highcharts/highcharts.src.es5.js');
require('./media/js/charts/chart.es5.js');
require('./media/js/charts/options.es5.js');
require('./media/js/widgets/calendar.es5.js');
require('./media/js/widgets/date_picker.es5.js');
require('./media/js/widgets/toggle.es5.js');
require('./media/js/widgets/dropdowns/base.es5.js');
require('./media/js/widgets/dropdowns/filterable_dropdown.es5.js');
require('./media/js/widgets/multi_selector.es5.js');
require('./media/js/reports/api/base.es5.js');
require('./media/js/reports/api/middleware/cache.es5.js');
require('./media/js/reports/api/middleware/callback_manager.es5.js');
require('./media/js/reports/api/middleware/values_formatter.es5.js');
require('./media/js/md5.es5.js');
require('./media/js/static/landing/marketing/trends/data/api.es5.js');
require('./media/js/static/landing/marketing/trends/views/lead_in_viewer.js');
require('./media/js/static/landing/marketing/trends/views/report_viewer.es5.js');
require('./media/js/static/landing/marketing/trends/views/time_range_viewer.es5.js');
require('./media/js/static/landing/marketing/trends/views/static_viewer.es5.js');
require('./media/js/static/landing/marketing/trends/util/ios_versions.es5.js');
require('./media/js/static/landing/marketing/trends/util/iphones.es5.js');
require('./media/js/static/landing/marketing/trends/widgets/trend_report.es5.js');
require('./media/js/static/landing/marketing/trends/widgets/phone_adoption.es5.js');
require('./media/js/static/landing/marketing/trends/widgets/os_adoption.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_fragmentation.es5.js');
require('./media/js/static/landing/marketing/trends/reports/android_vs_ios.es5.js');
require('./media/js/static/landing/marketing/trends/reports/android_manufacturer.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_models.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ipad_models.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_11.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_12.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_13.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_14.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_15.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_16.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_17.es5.js');
require('./media/js/static/landing/marketing/trends/reports/ios_18.es5.js');
require('./media/js/static/landing/marketing/trends/reports/android_os_adoption.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_Xs.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_11.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_12.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_13.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_14.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_15.es5.js');
require('./media/js/static/landing/marketing/trends/reports/iphone_16.es5.js');
require('./media/js/static/landing/marketing/trends/bootstrap.es5.js');
